import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { IJBPMAP } from '../../../models/IJBPPMAP'
import { PLANNING_BY_FY_FQ } from '../../config'
import { getMapValue } from '../../helpers//marketGrowth/getMapValue'
import { isMapDataPresent } from '../../helpers/marketGrowth/isMapDataPresent'

import styles from './SubCategoryMapRow.module.scss'

interface IProps {
  mapData: IJBPMAP[]
  fyear: number
  category: string
  subCategory: string
  l3Category: string
  tag: string
  isShowCalcActuals: boolean
  isShowFutureYears: boolean
  isUnits?: boolean
  hideIfEmpty?: boolean
}

export const SubCategoryMapRow = ({
  mapData,
  fyear,
  category,
  subCategory,
  l3Category,
  tag,
  isShowCalcActuals,
  isShowFutureYears,
  isUnits = false,
}: IProps) => {
  /** -------------------- Variables ----------------------- */

  const mapDataProps = useMemo(
    () => ({ mapData, fy: fyear, category, subCategory, l3Category, isUnits }),
    [category, fyear, isUnits, l3Category, mapData, subCategory]
  )

  const yearlyColSpan = useMemo(() => 6 + (isShowCalcActuals ? 1 : 0), [isShowCalcActuals])
  const isDataPresent = useMemo(() => isMapDataPresent(mapDataProps), [mapDataProps])

  const q1Map = useMemo(() => getMapValue({ ...mapDataProps, fq: 1 }), [mapDataProps])
  const q2Map = useMemo(() => getMapValue({ ...mapDataProps, fq: 2 }), [mapDataProps])
  const q3Map = useMemo(() => getMapValue({ ...mapDataProps, fq: 3 }), [mapDataProps])
  const q4Map = useMemo(() => getMapValue({ ...mapDataProps, fq: 4 }), [mapDataProps])
  const fyMap = useMemo(
    () => getMapValue({ ...mapDataProps, fq: PLANNING_BY_FY_FQ }),
    [mapDataProps]
  )
  const fy1Map = useMemo(
    () =>
      isShowFutureYears
        ? getMapValue({ ...mapDataProps, fy: fyear + 1, fq: PLANNING_BY_FY_FQ })
        : 0,
    [fyear, isShowFutureYears, mapDataProps]
  )
  const fy2Map = useMemo(
    () =>
      isShowFutureYears
        ? getMapValue({ ...mapDataProps, fy: fyear + 2, fq: PLANNING_BY_FY_FQ })
        : 0,
    [fyear, isShowFutureYears, mapDataProps]
  )

  /** -------------------- Render ----------------------- */

  if (!isDataPresent) {
    return <></>
  }

  return (
    <tr className={styles.row}>
      <th className={styles.guidance}>
        <Translation text={tag} span actionsInside />
      </th>
      <th colSpan={yearlyColSpan}></th>
      <th>{q1Map}</th>
      <th>{q2Map}</th>
      <th>{q3Map}</th>
      <th>{q4Map}</th>
      <th>{fyMap}</th>
      {isShowFutureYears && (
        <>
          <th>{fy1Map}</th>
          <th>{fy2Map}</th>
        </>
      )}
    </tr>
  )
}
